import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

export type UseAxiosQueryOptions<TResponse = void> = UseQueryOptions<
  AxiosResponse<TResponse>,
  AxiosError
>;

export const useAxiosQuery = <TResponse = void>(
  params: UseAxiosQueryOptions<TResponse>
) => useQuery<AxiosResponse<TResponse>, AxiosError>(params);
